import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Box,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  IconButton,
  Tooltip,
  Chip,
  Avatar,
  CircularProgress,
} from '@mui/material';
import {
  Search as SearchIcon,
  Receipt as ReceiptIcon,
  EventBusy as EventBusyIcon,
  Event as EventIcon,
  List as ListIcon,
  Person as PersonIcon,
} from '@mui/icons-material';
import { useStateValue } from '../../../contexto/store';
import HttpCliente from '../../../service/HttpCliente';
import TFacturas from '../TFacturas';
import {
  obtenerFacturasClienteUsuario,
  obtenerFacturasClienteUsuarioVencidas,
  obtenerFacturasClienteUsuarioAVencer,obtenerFacturasUsuario,
} from '../../../actions/CobranzasAction';
import ModalClientes from '../../GestionDeClientes/ModalClientes';
import { obtenerClientes,obtenerClientesPaginado  } from '../../../actions/ClientesAction';
import { useHistory } from 'react-router-dom';

export default function PanelFacturasPropias(props) {
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [radioValor, setRadioValor] = useState('todas');
  const [DataMF, setDataMF] = useState([]);
  const [modalBuscar, setModalBuscar] = useState(false);
  const [Datacl, setDatacl] = useState([]);
  const history = useHistory();
  const [cliente, setCliente] = useState({
    nombre: '',
    apellido: '',
    clientE_Id: '',
  });
  const [datosCargados, setDatosCargados] = useState(false);
  const [datosCargadosF, setDatosCargadosF] = useState(false);
  const [paginaClientes, setPaginaClientes] = useState(1);
const [tamanoPaginaClientes, setTamanoPaginaClientes] = useState(20);
const [totalClientes, setTotalClientes] = useState(0);
const [buscarCliente, setBuscarCliente] = useState('');
  const seleccionarCliente = (cliente) => {
    setCliente(cliente);
    setModalBuscar(false);
  };
  // const seleccionarFacturas = (facturas) => {
  //   /*RRR:FACTURAS/TAREA-01 enviamos la solicitud de tarea nueva con un estado donde pasamos
  //   las facturas a las que queremos crearle una tarea y una variable para que le componente 
  //   reconozca que se trata de una tarea que tiene facturas */
  //   facturas['facturas'] = true;
  //   history.push({ pathname: '/nuevaTarea', state: facturas });
  // };
  const seleccionarFacturas = (facturas) => {
  history.push({
    pathname: '/nuevaTarea',
    state: {
      origen: 'misFacturas',
      facturas: facturas,
    },
  });
};
  const radioValorHandleChange = (event) => {
    setRadioValor(event.target.value);
  };

  const irANuevaFactura = () => {
    props.history.push('/nuevaFactura');
  };
  const abrirModal = () => {
    setModalBuscar(true);
  };

  const cerrarModal = () => {
    setModalBuscar(false);
  };
  // useEffect(() => {
  //   obtenerClientes().then((response) => {
  //     const Data = response.data;
  //     setDatacl(Data);
  //     setDatosCargados(true);
  //   });
  //   if (cliente.clientE_Id !== '') {
  //     const cargarFacturasConTareas = async (promiseFacturas) => {
  //       try {
  //         const response = await promiseFacturas;
  //         if (response.status === 200) {
  //           const facturasData = response.data;

  //           //  Traer historial de tareas por factura (en paralelo)
  //           const tareasPromises = facturasData.map((f) =>
  //             HttpCliente.get(`/COBRANZAS/historialTareaFactura/${f.id}`)
  //               .then((res) => ({ id: f.id, tareas: res.data }))
  //               .catch(() => ({ id: f.id, tareas: [] }))
  //           );

  //           const tareasResults = await Promise.all(tareasPromises);

  //           //  Unir tareas con facturas
  //           const facturasMarcadas = facturasData.map((factura) => {
  //             const tareasFactura = tareasResults.find(
  //               (t) => t.id === factura.id
  //             )?.tareas;

  //             const tieneTareas = tareasFactura && tareasFactura.length > 0;

  //             const tienePendientes = tareasFactura?.some(
  //               (t) => t.completado === null
  //             );

  //             return {
  //               ...factura,
  //               tieneTareas,
  //               tienePendientes,
  //             };
  //           });

  //           //  Ordenar: primero las que no tienen tareas, luego las demás
  //           const facturasOrdenadas = facturasMarcadas.sort((a, b) => {
  //             if (!a.tieneTareas && b.tieneTareas) return -1;
  //             if (a.tieneTareas && !b.tieneTareas) return 1;
  //             return 0;
  //           });

  //           setDataMF(facturasOrdenadas);
  //           setDatosCargadosF(true);
  //         } else if (response.status === 500) {
  //           dispatch({
  //             type: 'OPEN_SNACKBAR',
  //             openMensaje: {
  //               open: true,
  //               mensaje:
  //                 'Debe Seleccionar el cliente del cual quiere consultar las facturas',
  //             },
  //           });
  //         } else {
  //           console.log('ERROR SIN MANEJAR');
  //         }
  //       } catch (err) {
  //         console.error('Error cargando facturas', err);
  //       }
  //     };

  //     switch (radioValor) {
  //       case 'todas':
  //         cargarFacturasConTareas(
  //           obtenerFacturasClienteUsuario(
  //             sesionUsuario.usuario.userName,
  //             cliente.clientE_Id
  //           )
  //         );
  //         break;
  //       case 'vencidas':
  //         cargarFacturasConTareas(
  //           obtenerFacturasClienteUsuarioVencidas(
  //             sesionUsuario.usuario.userName,
  //             cliente.clientE_Id
  //           )
  //         );
  //         break;
  //       case 'avencer':
  //         cargarFacturasConTareas(
  //           obtenerFacturasClienteUsuarioAVencer(
  //             sesionUsuario.usuario.userName,
  //             cliente.clientE_Id
  //           )
  //         );
  //         break;

  //       default:
  //         setDataMF([]);
  //     }
  //   }
  // }, [radioValor, sesionUsuario, cliente, dispatch]);


/// zinriii

  //   useEffect(() => {
//   obtenerClientes().then((response) => {
//     const Data = response.data;
//     setDatacl(Data);
//     setDatosCargados(true);
//   });
// }, []);

const cargarClientesPaginados = async (
  pagina = 1,
  tamanoPagina = 20,
  buscar = ''
) => {
  try {
    setDatosCargados(false);

    const response = await obtenerClientesPaginado(
      pagina,
      tamanoPagina,
      buscar
    );

    if (response && response.status === 200) {
      const resultado = response.data;

      setDatacl(resultado.data || resultado.Data || []);
      setTotalClientes(resultado.totalRegistros || resultado.TotalRegistros || 0);
    } else {
      setDatacl([]);
      setTotalClientes(0);
    }

    setDatosCargados(true);
  } catch (error) {
    console.error('Error al cargar clientes paginados:', error);
    setDatacl([]);
    setTotalClientes(0);
    setDatosCargados(true);
  }
};

useEffect(() => {
  cargarClientesPaginados(1, tamanoPaginaClientes, buscarCliente);
}, []);
useEffect(() => {
  const cargarFacturasConTareas = async (promiseFacturas) => {
    try {
      setDatosCargadosF(false);
      setDataMF([]);

      const response = await promiseFacturas;

      if (response && response.status === 200) {
        let facturasData = response.data || [];

        if (cliente.clientE_Id === '') {
          const hoy = new Date();

          if (radioValor === 'vencidas') {
            facturasData = facturasData.filter((f) => {
              return f.fechavencimiento && new Date(f.fechavencimiento) < hoy;
            });
          }

          if (radioValor === 'avencer') {
            facturasData = facturasData.filter((f) => {
              return f.fechavencimiento && new Date(f.fechavencimiento) >= hoy;
            });
          }
        }

        // Primero mostramos las facturas sin esperar los historiales
        const facturasIniciales = facturasData.map((factura) => ({
          ...factura,
          tieneTareas: false,
          tienePendientes: false,
        }));

        setDataMF(facturasIniciales);
        setDatosCargadosF(true);

        // Luego cargamos las tareas en segundo plano
        const tareasPromises = facturasData.map((f) =>
          HttpCliente.get(`/COBRANZAS/historialTareaFactura/${f.id}`)
            .then((res) => ({ id: f.id, tareas: res.data }))
            .catch(() => ({ id: f.id, tareas: [] }))
        );

        const tareasResults = await Promise.all(tareasPromises);

        const facturasMarcadas = facturasData.map((factura) => {
          const tareasFactura = tareasResults.find(
            (t) => t.id === factura.id
          )?.tareas;

          const tieneTareas = tareasFactura && tareasFactura.length > 0;

          const tienePendientes = tareasFactura?.some(
            (t) => t.completado === null
          );

          return {
            ...factura,
            tieneTareas,
            tienePendientes,
          };
        });

        const facturasOrdenadas = facturasMarcadas.sort((a, b) => {
          if (!a.tieneTareas && b.tieneTareas) return -1;
          if (a.tieneTareas && !b.tieneTareas) return 1;
          return 0;
        });

        setDataMF(facturasOrdenadas);
      } else {
        setDataMF([]);
        setDatosCargadosF(true);
      }
    } catch (err) {
      console.error('Error cargando facturas', err);
      setDataMF([]);
      setDatosCargadosF(true);
    }
  };

  const userName = sesionUsuario?.usuario?.userName;

  if (!userName) {

    return;
  }

  if (cliente.clientE_Id !== '') {
    switch (radioValor) {
      case 'todas':
        cargarFacturasConTareas(
          obtenerFacturasClienteUsuario(userName, cliente.clientE_Id)
        );
        break;

      case 'vencidas':
        cargarFacturasConTareas(
          obtenerFacturasClienteUsuarioVencidas(userName, cliente.clientE_Id)
        );
        break;

      case 'avencer':
        cargarFacturasConTareas(
          obtenerFacturasClienteUsuarioAVencer(userName, cliente.clientE_Id)
        );
        break;

      default:
        setDataMF([]);
        setDatosCargadosF(true);
        break;
    }
  } else {
    cargarFacturasConTareas(obtenerFacturasUsuario(userName));
  }
}, [radioValor, sesionUsuario?.usuario?.userName, cliente.clientE_Id]);
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header personalizado */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          color: 'white',
          p: 3,
          mb: 3,
          borderRadius: 2,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -20,
            right: -20,
            opacity: 0.2,
            transform: 'rotate(-15deg)',
          }}
        >
          <ReceiptIcon sx={{ fontSize: 120 }} />
        </Box>
        <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar
            sx={{
              width: 56,
              height: 56,
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              border: '3px solid rgba(255, 255, 255, 0.3)',
            }}
          >
            <PersonIcon sx={{ fontSize: 32 }} />
          </Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
              Mis Facturas de Clientes
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {sesionUsuario.usuario.nombrecompleto}
            </Typography>
          </Box>
          {DataMF.length > 0 && (
            <Chip
              label={`${DataMF.length} facturas`}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                fontWeight: 600,
                fontSize: '0.9rem',
              }}
            />
          )}
        </Box>
      </Paper>

      {/* Búsqueda de cliente */}
      <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Tooltip title="Buscar Cliente">
            <IconButton
              onClick={abrirModal}
              sx={{
                backgroundColor: 'primary.main',
                color: 'white',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                  animation: 'pulse 1s ease-in-out infinite',
                },
                '@keyframes pulse': {
                  '0%, 100%': { opacity: 1 },
                  '50%': { opacity: 0.6 },
                },
              }}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
          <TextField
            fullWidth
            value={cliente.nombre + ' ' + cliente.apellido}
            variant="outlined"
            placeholder="Buscar cliente para filtrar facturas..."
            disabled={true}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              },
            }}
          />
        </Box>
      </Paper>

      {/* Filtros con RadioGroup */}
      <Paper elevation={1} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
          Filtrar por Estado
        </Typography>
        <RadioGroup
          row
          value={radioValor}
          onChange={radioValorHandleChange}
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <FormControlLabel
            value="todas"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ListIcon sx={{ fontSize: 20, color: 'primary.main' }} />
                <Typography>Todas</Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="vencidas"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EventBusyIcon sx={{ fontSize: 20, color: 'error.main' }} />
                <Typography>Vencidas</Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="avencer"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EventIcon sx={{ fontSize: 20, color: 'warning.main' }} />
                <Typography>A Vencer</Typography>
              </Box>
            }
          />
        </RadioGroup>
      </Paper>

      {/* Tabla de Facturas */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {/* {datosCargadosF ? (
          <TFacturas seleccionarFacturas={seleccionarFacturas} rows={DataMF} />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <SearchIcon sx={{ fontSize: 64, color: 'text.disabled' }} />
            <Typography variant="body1" color="text.secondary">
              No se encontraron facturas para mostrar
            </Typography>
          </Box>
        )} */}
        {!datosCargadosF ? (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 8,
      gap: 2,
    }}
  >
    <CircularProgress />
    <Typography variant="body1" color="text.secondary">
      Cargando facturas...
    </Typography>
  </Box>
) : DataMF.length === 0 ? (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 8,
      gap: 2,
    }}
  >
    <SearchIcon sx={{ fontSize: 64, color: 'text.disabled' }} />
    <Typography variant="body1" color="text.secondary">
      No se encontraron facturas para mostrar
    </Typography>
  </Box>
) : (
  <TFacturas seleccionarFacturas={seleccionarFacturas} rows={DataMF} />
)}
      </Paper>

      {/* Modal de Clientes */}
      {/* <ModalClientes
        data={Datacl}
        open={modalBuscar}
        handleClose={cerrarModal}
        seleccionarCliente={seleccionarCliente}
        datosCargados={datosCargados}
      /> */}
      <ModalClientes
  data={Datacl}
  open={modalBuscar}
  handleClose={cerrarModal}
  seleccionarCliente={seleccionarCliente}
  datosCargados={datosCargados}

  totalRegistros={totalClientes}
  pagina={paginaClientes}
  tamanoPagina={tamanoPaginaClientes}
  buscarCliente={buscarCliente}

  onBuscarCliente={(texto) => {
    setBuscarCliente(texto);
    setPaginaClientes(1);
    cargarClientesPaginados(1, tamanoPaginaClientes, texto);
  }}

  onCambiarPagina={(nuevaPagina) => {
    setPaginaClientes(nuevaPagina);
    cargarClientesPaginados(
      nuevaPagina,
      tamanoPaginaClientes,
      buscarCliente
    );
  }}
/>
    </Container>
  );
}
